module.exports = __webpack_public_path__ + "img/product3.ace882cd.jpg";